<template>
  <div class="pb-2 section">
    <div class="container">
      <div class="container__inner px-1.5">
        <p class="p-0 py-2 m-0 text-xl lg:text-4xl lg:pb-2" id="quiz_block">
          {{ question.title }}
        </p>

        <div
          v-if="question.description"
          class="pb-2"
          v-html="question.description"
        ></div>

        <div v-if="question.media" class="pb-2">
          <img :src="question.media.guid" />
        </div>

        <form
          name="quiz-form"
          class="relative quiz-form"
          method="post"
          id="lineContainer"
        >
          <div
            ref="elmPoint"
            id="elm-point"
            class="absolute hidden w-0 h-0"
          ></div>
          <div
            class="flex flex-wrap justify-between w-full select-none gap-x-4"
          >
            <div class="flex-1 w-[46%]">
              <div id="leftList" ref="leftItems">
                <div
                  v-for="(element, idx) in leftList"
                  class="relative flex items-center bg-white question-drag-item border border-solid border-dark rounded-2xl p-1.5 mb-1 text-sm lg:text-lg"
                >
                  <span v-html="element.title"></span>
                  <div
                    @mousedown="clickElem"
                    :id="'left_' + element.id"
                    :data-id="element.id"
                    data-column="left"
                    class="handler drag-item__icon bg-white w-1.5 h-1.5 border border-solid border-dark flex items-center justify-center rounded cursor-pointer"
                  >
                    <span
                      class="drag-item__icon__inner w-0.75 h-0.75 border border-solid border-black flex items-center justify-center rounded"
                      >&nbsp;</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="flex-none w-[8%]">&nbsp;</div>
            <div class="flex-1 w-[46%]">
              <div id="rightList" ref="rightItems">
                <div
                  v-for="(element, idx) in rightList"
                  class="relative flex items-center bg-dark text-white answer-drag-item border border-solid border-dark rounded-2xl p-1.5 mb-1 text-sm lg:text-lg"
                >
                  <span v-html="element.title"></span>
                  <div
                    @mousedown="clickElem"
                    :id="'right_' + element.id"
                    :data-id="element.id"
                    data-column="right"
                    class="handler drag-item__icon bg-white w-1.5 h-1.5 border border-solid border-dark flex items-center justify-center rounded cursor-pointer"
                  >
                    <span
                      class="drag-item__icon__inner w-0.75 h-0.75 border border-solid border-dark flex items-center justify-center rounded"
                      >&nbsp;</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- .grid -->
          <div class="py-2 lg:py-4">
            <button
              type="button"
              class="bt"
              @click="$emit('nextQuestion')"
              :disabled="choices.length === 0"
            >
              <span>Question suivante</span>
            </button>
          </div>
        </form>
      </div>
      <!-- .container__inner -->
    </div>
    <!-- .container -->
  </div>
  <!-- .section -->
</template>
<script setup>
import { onUnmounted, onMounted, onUpdated, ref } from "vue";
import LeaderLine from "@/leader-line-ext";
const props = defineProps({
  question: {
    type: Object,
    required: true,
  },
  modelValue: {
    type: Array,
    required: true,
  },
  answer: {},
});
const answers = ref(Object.values(props.question.answers));
const emit = defineEmits(["update:modelValue", "nextQuestion"]);
const choices = ref(props.modelValue);
const change = (left, right) => {
  choices.value[column] = source.map((a) => a.id);
  emit("update:modelValue", choices.value);
};

const leftList = ref(answers.value.filter((elt) => elt.column == 0));

// https://stackoverflow.com/questions/33604137/how-do-i-shuffle-a-javascript-array-ensuring-each-index-is-in-a-new-position-in
const shuffle = (items) => {
  for (var i = items.length; i-- > 1; ) {
    var j = Math.floor(Math.random() * i);
    var tmp = items[i];
    items[i] = items[j];
    items[j] = tmp;
  }

  return items;
};

const rightList = ref(shuffle(answers.value.filter((elt) => elt.column == 1)));
const connectMode = ref(false);
let line;

function updateLine(event) {
  const container = document.getElementById("lineContainer");
  const rect = container.getBoundingClientRect();
  elmPoint.value.style.left = `${event.clientX - rect.left}px`;
  elmPoint.value.style.top = `${event.clientY - rect.top}px`;
  line.position();
}

let startPoint = null;
const elmPoint = ref(null);
const leftItems = ref([]);
const rightItems = ref([]);
const lines = ref([]);

const removeLine = (id) => {
  lines.value.find((line, idx) => {
    if (line && line.left == id) {
      line.line.remove();
      delete lines.value[idx];
    }
  });
  lines.value.find((line, idx) => {
    if (line && line.right == id) {
      line.line.remove();
      delete lines.value[idx];
    }
  });
  updateChoices();
};

const updateChoices = () => {
  choices.value = Object.fromEntries(
    lines.value
      .map((line) => {
        return [line.left, line.right];
      })
      .filter((line) => line)
  );
  emit("update:modelValue", choices.value);
};

const clickElem = (event) => {
  // get closest .handler
  let target = event.target;
  if (!target.classList.contains("handler"))
    target = target.closest(".handler");
  if (startPoint === null) {
    startPoint = target;
  }

  // remove exiting line starting/ending from this point
  removeLine(target.dataset.id);

  if (connectMode.value) {
    if (target.dataset.column != startPoint.dataset.column) {
      line.setOptions({
        end: target,
        endPlug: "behind",
        dash: false,
      });

      if (target.dataset.column == "right") {
        lines.value.push({
          left: startPoint.dataset.id,
          right: target.dataset.id,
          line: line,
        });
      } else {
        lines.value.push({
          left: startPoint.dataset.id,
          right: target.dataset.id,
          line: line,
        });
      }
      updateChoices();
    } else {
      // Abort
      line.remove();
    }
    elmPoint.value.style.display = "none";
    startPoint.classList.remove("connect-mode");

    startPoint = null;
    connectMode.value = false;
  } else {
    // Start
    elmPoint.value.style.display = "block";
    line = new LeaderLine({
      start: startPoint,
      end: elmPoint.value,
      parent: document.getElementById("lineContainer"),
      endPlug: "disc",
      dash: {
        animation: true,
      },
    });
    startPoint.classList.add("connect-mode");
    connectMode.value = true;
    updateLine(event);
  }
};

document.addEventListener("mousemove", (event) => {
  if (connectMode.value) {
    updateLine(event);
  }
});

onMounted(() => {
  window.addEventListener("resize", () => {
    setBoxesHeight();
  });
  setBoxesHeight();
});

onUpdated(() => {
  setBoxesHeight();
});

const setBoxesHeight = () => {
  const allBoxes = document.querySelectorAll(
    "#leftList > div, #rightList > div"
  );
  // reset height
  allBoxes.forEach((elt) => (elt.style.height = "unset"));
  // get max height
  const maxHeight = Math.max(
    ...Object.values(allBoxes).map((elt) => elt.offsetHeight)
  );
  // apply height
  allBoxes.forEach((elt) => (elt.style.height = maxHeight + "px"));
};

onUnmounted(() => {
  lines.value.forEach((line) => {
    line.line.remove();
  });
});
</script>
